<template>
  <div id="dispatchCustomer">
    <Panel :title="$t('customer.customer_information') + ' (' + userId + ')'">
      <div class="columns" v-if="customer">
        <div class="column">
          <InformationBlock
            :title="$t('customer.contact_information')"
            icon="/icon/user.svg"
            :data="[
              {label: $t('fullName'), value: fullName },
              {label: $t('phoneNumber'), value: customer.contact.phoneNumber},
              {label: $t('email'), value: customer.contact.email},
              {label: $t('language'), value: customer.language},
              {label: $t('remark'), value: customer.remark }
            ]"
          />
        </div>
        <div class="column">
          <InformationBlock
            v-for="(addr, addrIndex) of customer.addresses"
            :key="`address-${addrIndex}`"
            :title="$t('address.address')"
            icon="/icon/location.svg"
            :data="Object.entries(addr)
                .sort((a1, a2) => addressFieldsOrder.indexOf(a1[0]) < addressFieldsOrder.indexOf(a2[0]) ? -1 : 1)
                .map(([k, v]) => ({label: $t(`address.${k}`), value: v}))"
          />
        </div>
      </div>
      <div v-if="!customer">
        {{$t('customers.no_information')}}
      </div>
    </Panel>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import Datatable from "@/components/Datatable.vue";
  import InformationBlock from "@/components/tools/InformationBlock.vue";

  export default {
    name: "DispatchCustomer",

    components: { Datatable, InformationBlock },

    data() {
      return {
        addressFieldsOrder: ['fullAddress', 'app', 'zip', 'city', 'state', 'country', 'lat', 'lng', 'name', 'note'],
        customer: {
          firstName: "",
          lastName: "",
          language: "",
          addresses: [],
          birthDate: "",
          remark: "",
          favoriteCompany: "",
          gender: "",
          id: null,
          image: null,
          contact: {
            email: "",
            phoneNumber: "",
            preference: "",
            messagingConsent: ""
          }
        }
      }
    },

    methods: {
      ...mapActions(["getDispatchCustomer"]),
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "customer.title";
      this.$store.state.pageIcon = "/icon/user.svg";

      let customerId = this.$route.query.id;
      let [customer, branch] = await Promise.all([
        this.getDispatchCustomer({id: customerId}),
        this.$store.getters.getContextBranch,
      ]);
      if (customer) {
        this.customer = customer;
      } else {
        toast(this.$t("error.no_server"), "error");
      }
    },

    computed: {
      isSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin
      },
      userId() {
        return this.$route.query.id
      },
      branchId() {
        return this.$route.query.branch
      },
      fullName() {
        let str = '';
        if (this.customer && this.customer.firstName) {
          str += this.customer.firstName;
          str += ' ';
        }
        if (this.customer && this.customer.lastName) {
          str += this.customer.lastName;
        }
        return str;
      },
      dispatchUser() {
        return this.customer;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>